t = require('app/scripts/views/internal/teacup-with-helpers')('calendar_day')

body = ->
  t.div { class: 'calendar-day js-expand-day ' + t.mustacheBlock('isToday', (-> 'today')) }, ->
    t.div '.day-header.u-clearfix.js-toggle-day', ->
      t.h3 '.date', ->
        t.text t.mustacheVar('date')
      t.div '.quiet.num-cards', ->
        t.div '.day-cards-header'
      t.a '.close-button.icon-sm.icon-close.dark-hover', { href: '#' }

    t.div '.calendar-day-list.u-fancy-scrollbar.js-calendar-sortable', ->
      t.div '.calendar-cards-section.js-cards', ->
      t.div '.js-check-items-section', ->
        t.span '.calendar-list-header', ->
          t.icon 'checklist'
          t.text ' '
          t.format 'checklist-items'
        t.div '.js-check-items', ->

    t.mustacheBlock '__ed', ->
      t.a '.calendar-card-composer.button.subtle.js-open-card-composer', { href: '#' }, ->
        t.format 'add-a-card-ellipsis'

module.exports = ->
  # We need an inner spacer div to fix two browser rendering bugs at once:
  #
  # 1. Chrome inserts extra padding at the bottom of table cells for no reason,
  #    so day-cells in the month view have extra bottom padding.
  # 2. Firefox does not allow anchoring to relative table-cell elements, so the
  #    expanded day-cell anchors to the .calendar-content class instead. We must
  #    insert a spacer Div in between for firefox to anchor correctly

  if t.mustacheVar('monthView')
    t.div '.calendar-day-spacer-div', body
  else
    body()
